var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 747.182,
    height: 623.865,
    viewBox: "0 0 747.182 623.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #dce6ef;\r\n      }\r\n\r\n      .cls-1 {\r\n        opacity: 0.326;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #258dcd;\r\n      }\r\n\r\n      .cls-4, .cls-6, .cls-8, .cls-9 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #1a55b5;\r\n      }\r\n\r\n      .cls-4, .cls-6 {\r\n        stroke-width: 0.868px;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #ffaa45;\r\n      }\r\n\r\n      .cls-6, .cls-9 {\r\n        stroke: #6aa5fe;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #1874ad;\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke: #2a294f;\r\n        stroke-width: 0.78px;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #ff746f;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #2a294f;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #fe9280;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #e86767;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #ffb5b1;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #e65c5c;\r\n      }\r\n\r\n      .cls-17, .cls-20, .cls-22, .cls-23 {\r\n        fill: #777470;\r\n      }\r\n\r\n      .cls-17 {\r\n        opacity: 0.288;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #ffc957;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #fff4dd;\r\n      }\r\n\r\n      .cls-20 {\r\n        opacity: 0.2;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #d3eaf5;\r\n      }\r\n\r\n      .cls-22 {\r\n        opacity: 0.05;\r\n      }\r\n\r\n      .cls-23 {\r\n        opacity: 0.15;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #f49290;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #51aae2;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #105986;\r\n      }\r\n\r\n      .cls-27, .cls-28 {\r\n        fill: #414d6b;\r\n        font-family: FiraSans-Bold, Fira Sans;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-27 {\r\n        font-size: 171px;\r\n      }\r\n\r\n      .cls-28 {\r\n        font-size: 36px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-586.408 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(-22.479 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    className: "cls-1",
    d: "M19624.389,309.4c85.172,141.087-206.516,461.922,296.086,494.939s532.7-481.379,302.777-557.422S19539.217,168.318,19624.389,309.4Z",
    transform: "translate(-19005 57)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(619 292.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(288.461 160.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-2",
    d: "M552.421,297.241c-5.2-12.619-9-26.043-13.214-40.273-2.812-9.531-7.451-20.271-17.291-23.224-9.7-2.953-19.962,3.088-26.006,11.008-5.9,7.786-8.856,17.318-13.917,25.641-9.137,15.17-25.444,21.479-38.939,8.189-19.259-19.063-27.834-44.972-40.064-68.2-8.856-16.781-16.307-36.514-27.412-52.087-17.01-23.627-40.345-43.9-71.272-43.9-19.681,2.819-36.971,19.465-48.639,40.273s-18.556,45.509-24.32,70.076C220.8,269.587,212.932,315.364,205.2,361.141l390.94-4.3c-1.546,0-11.105-12.216-12.933-13.961C568.166,329.057,559.169,313.887,552.421,297.241Z",
    transform: "translate(-205.2 -114.4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(217.973 117.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-3",
    d: "M415.282,293.4c-.7,15.182-17.291,41.751-32.473,41.048s-23.336-28.537-22.492-43.719c.7-15.182,17.01-91.233,32.192-90.531C407.551,200.9,415.985,278.221,415.282,293.4Z",
    transform: "translate(-360.258 -200.197)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    className: "cls-4",
    x1: 7.732,
    y2: 123.144,
    transform: "translate(23.676 9.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-5",
    d: "M377.04,278.862a107.925,107.925,0,0,0-7.732,23.9c-.843,4.217-1.265,8.716.562,12.652,2.109,4.217,6.748,6.607,11.387,7.45,11.246,1.827,22.633-5.061,29.24-14.339s9.559-20.805,12.089-31.911c2.109-8.716,4.077-17.713,8.013-25.866,1.687-3.514,11.527-17.01,6.888-20.524-6.326-4.92-24.741.422-36.409,13.214C391.378,253.98,382.944,265.788,377.04,278.862Z",
    transform: "translate(-356.878 -188.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-6",
    d: "M377.6,319.6s13.636-53.138,46.53-83.5",
    transform: "translate(-353.221 -185.629)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(273.56 188.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-7",
    d: "M439.637,257.429c-1.125,2.109-3.374,3.514-5.342,4.639-2.39,1.406-5.061,2.53-7.591,3.8a91,91,0,0,0-9.7,5.061,28.342,28.342,0,0,0-5.9,4.78,77.565,77.565,0,0,1,9.419-16.026c4.78-6.185,9.7-9.278,14.62-9.278h.281a5.261,5.261,0,0,1,3.514,1.125C440.761,252.79,440.761,255.6,439.637,257.429Z",
    transform: "translate(-395.215 -250.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-7",
    d: "M445.057,282.536c-1.968,1.406-4.5,1.687-6.748,1.968-2.812.141-5.623.141-8.435.141a92.9,92.9,0,0,0-10.824.422,30.418,30.418,0,0,0-7.451,1.687,70.3,70.3,0,0,1,15.323-10.4q10.543-5.272,17.291-2.109c.141,0,.141.141.281.141a5.233,5.233,0,0,1,2.671,2.53C448.009,278.881,446.744,281.271,445.057,282.536Z",
    transform: "translate(-395.012 -241.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-7",
    d: "M431.456,295.736a8.766,8.766,0,0,1-4.217-2.249,37.688,37.688,0,0,1-4.217-3.936c-1.827-1.687-3.655-3.374-5.623-4.92a15.979,15.979,0,0,0-4.5-2.53,50.639,50.639,0,0,1,12.511,1.968c5.2,1.546,8.294,3.936,9.559,7.029,0,.141,0,.141.141.281a3.223,3.223,0,0,1,.141,2.53C434.689,295.314,432.862,295.876,431.456,295.736Z",
    transform: "translate(-394.485 -237.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-8",
    d: "M399.8,313.026s.141-32.473,39.783-60.026",
    transform: "translate(-399.8 -249.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-8",
    d: "M399.8,303.247S412.03,277.1,445.065,277.1",
    transform: "translate(-399.8 -239.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-8",
    d: "M412.6,282.3s6.326-.422,19.681,9.559",
    transform: "translate(-394.606 -237.457)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(0 222.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-2",
    d: "M221.125,348.486c-9.137-34.722-18.415-69.3-29.24-102.9-6.045-18.978-12.792-37.815-22.07-53S148.167,166.3,135.8,166.3c-19.118,3.655-31.348,22.492-39.5,43.438-5.342,13.636-7.872,30.224-11.668,44.7-5.2,19.962-7.872,41.61-17.853,59.042-6.888,12.23-17.572,9.137-24.741-1.828-3.936-6.045-6.748-13.214-11.246-18.837-4.5-5.482-11.387-9.137-17.15-5.623s-7.591,12.652-8.294,20.524c-.984,12.089-2.109,23.195-3.936,33.879-.422,2.39-.843,4.639-1.406,6.888Z",
    transform: "translate(0 -166.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-5",
    d: "M124.208,290.468c-5.764-6.607-12.933-12.371-15.323-20.665-1.687-6.045-.422-12.511.281-18.837s.422-13.214-3.655-18.134c-3.374-3.936-8.575-5.764-13.776-6.748-5.061-1.125-10.4-1.827-14.9-4.358-7.31-4.217-5.9-11.387-9.84-17.572-4.358-7.029-14.76-16.026-23.476-11.387-9.278,4.92-7.872,19.962-1.687,26.569,4.077,4.358,9.419,8.575,9.981,14.62.843,9-9.419,17.15-6.607,25.725,2.109,6.326,10.121,8.575,14.058,13.917s3.093,12.792.843,19.118c-2.249,6.185-5.9,11.949-7.31,18.415-2.952,13.214,7.451,22.351,19.259,25.3,10.824,2.671,34.3,1.406,34.3,1.406,8.435-2.952,17.712-10.262,22.211-18.275a23.281,23.281,0,0,0,1.265-20.243A28.574,28.574,0,0,0,124.208,290.468Z",
    transform: "translate(14.962 -156.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-9",
    d: "M49.1,202.6s40.064,61.853,44.422,130.595",
    transform: "translate(19.923 -151.571)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(26.897 133.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-7",
    d: "M23.991,262.243a3.806,3.806,0,0,1,2.671-.843h.281c3.8,0,7.451,2.39,11.105,7.029a59.68,59.68,0,0,1,7.169,12.09A22.655,22.655,0,0,0,40.72,277c-2.39-1.406-4.92-2.671-7.31-3.8-1.968-.843-3.936-1.827-5.764-2.811a10.9,10.9,0,0,1-4.077-3.514C22.726,265.336,22.726,263.228,23.991,262.243Z",
    transform: "translate(-17.572 -261.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-7",
    d: "M19.368,281.454a4.145,4.145,0,0,1,2.109-1.968c.141,0,.141-.141.281-.141q5.061-2.319,13.074,1.687A54.944,54.944,0,0,1,46.5,288.9a23.478,23.478,0,0,0-5.623-1.265,80.368,80.368,0,0,0-8.294-.281c-2.109,0-4.217,0-6.466-.141a11.53,11.53,0,0,1-5.2-1.406C19.649,284.828,18.665,283,19.368,281.454Z",
    transform: "translate(-19.133 -254.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-7",
    d: "M25.427,294.4a3.271,3.271,0,0,1,.141-1.968v-.141c.984-2.39,3.374-4.217,7.31-5.342A39.973,39.973,0,0,1,42.3,285.4a14,14,0,0,0-3.374,1.968,35.8,35.8,0,0,0-4.217,3.655c-.984.984-2.109,1.968-3.233,2.952a6.519,6.519,0,0,1-3.233,1.687A2.466,2.466,0,0,1,25.427,294.4Z",
    transform: "translate(-16.617 -251.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-8",
    d: "M55.983,308.806s-.141-24.6-30.083-45.406",
    transform: "translate(-16.388 -260.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-8",
    d: "M57.16,301.381S47.882,281.7,23,281.7",
    transform: "translate(-17.564 -253.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-8",
    d: "M41.9,285.6s-4.78-.422-14.9,7.31",
    transform: "translate(-15.941 -251.582)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(302.659 139.516)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-10",
    width: 6.466,
    height: 7.872,
    transform: "translate(127.502 277.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-11",
    d: "M310.828,291.1l3.374,1.125,3.093-1.125,2.812,6.466H294.1l9.84-3.233Z",
    transform: "translate(-183.327 -8.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-10",
    d: "M354.49,294.672h6.466l-2.39-7.872H352.1Z",
    transform: "translate(-159.793 -9.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-11",
    d: "M360.678,291.1l-3.374,1.125-3.093-1.125-2.812,6.466h25.866l-9.7-3.233Z",
    transform: "translate(-160.077 -8.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-12",
    d: "M299.839,99.581c-.843.7-8.716,5.342-8.716,5.342L285.5,97.753l1.687-8.153,12.09.7,2.109,6.045C301.807,97.894,300.963,98.878,299.839,99.581Z",
    transform: "translate(-186.816 -78.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-13",
    d: "M298.474,90.262,300.3,95.6l-5.623,2.249a5.585,5.585,0,0,1-3.374.281,5.287,5.287,0,0,1-3.8-5.482l.422-2.952Z",
    transform: "translate(-186.013 -78.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-14",
    d: "M293.3,97.07l4.78.7,2.671-4.5a1.671,1.671,0,0,0-.562-2.39h0a1.671,1.671,0,0,0-2.39.562Z",
    transform: "translate(-183.651 -77.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-15",
    d: "M291.1,109.1l-9.981,2.53L277.6,140.448l11.527.422Z",
    transform: "translate(-190.022 -70.248)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0 4.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-16",
    d: "M388.731,135.379,371.3,133.129l3.936-31.629,17.431,2.249a15.835,15.835,0,0,1,13.776,17.713h0A15.84,15.84,0,0,1,388.731,135.379Z",
    transform: "translate(-152.002 -77.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-17",
    d: "M389.575,123.462l-17.431-2.249-.843,7.169,17.431,2.249A15.742,15.742,0,0,0,406.444,113.2,15.8,15.8,0,0,1,389.575,123.462Z",
    transform: "translate(-152.002 -72.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-18",
    d: "M422.994,139.887,238.7,115.989,242.636,84.5l184.294,23.757Z",
    transform: "translate(-205.805 -84.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-19",
    d: "M215.3,95.887l32.895,20.1L252.131,84.5Z",
    transform: "translate(-215.3 -84.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-20",
    d: "M215.3,92.6l32.895,20.1.984-7.732Z",
    transform: "translate(-215.3 -81.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-11",
    d: "M226.265,90.2,215.3,93.574l9.84,6.045Z",
    transform: "translate(-215.3 -82.187)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    className: "cls-21",
    width: 15.323,
    height: 31.77,
    transform: "translate(221.221 23.766) rotate(7.175)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    className: "cls-21",
    width: 5.201,
    height: 34.582,
    transform: "translate(231.326 23.703) rotate(7.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-20",
    d: "M432.975,134.295,238.7,109.132l.984-7.732,194.275,25.163Z",
    transform: "translate(-205.805 -77.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-22",
    d: "M435.216,117.254,240.8,92.232l.984-7.732L436.2,109.522Z",
    transform: "translate(-204.953 -84.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    className: "cls-23",
    width: 5.201,
    height: 10.543,
    transform: "translate(228.421 47.519) rotate(7.175)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-14",
    d: "M334.8,181.754l2.53-6.748,8.716-.7c1.546-.141,3.093.843,3.233,2.109h0a2.687,2.687,0,0,1-2.671,2.812Z",
    transform: "translate(-166.812 -48.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-14",
    d: "M331.894,177.519l4.5,6.748,8.575-1.828-9.7-14.339-1.827,1.265A5.874,5.874,0,0,0,331.894,177.519Z",
    transform: "translate(-168.405 -51.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-15",
    d: "M337.614,183.06l29.24-30.645L351.531,148.9,334.1,175.891Z",
    transform: "translate(-167.096 -58.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-15",
    d: "M349.581,153.237a6.667,6.667,0,1,0,3.233-8.856A6.629,6.629,0,0,0,349.581,153.237Z",
    transform: "translate(-161.069 -59.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-15",
    d: "M361.386,166.866l9-9.559-31.489-37.534a7.43,7.43,0,0,0-11.246-.843h0c-3.233,3.233-2.952,14.479.7,17.291Z",
    transform: "translate(-170.625 -69.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    className: "cls-24",
    width: 12.933,
    height: 20.524,
    transform: "translate(152.035 56.555) rotate(-175.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-15",
    d: "M282.884,128.306a5.844,5.844,0,1,0,6.185,5.482A5.81,5.81,0,0,0,282.884,128.306Z",
    transform: "translate(-190.104 -65.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-15",
    d: "M278.6,134.179l5.9,10.543,35.987-8.153c4.358-1.125,6.748-11.808,5.061-16.026h0a7.491,7.491,0,0,0-10.684-3.655Z",
    transform: "translate(-189.616 -69.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-15",
    d: "M345.274,193.518l3.936-68.6a6.368,6.368,0,0,0-5.342-7.872l-32.192-1.125a6.321,6.321,0,0,0-7.169,6.185L297.9,205.466Z",
    transform: "translate(-181.785 -70.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-3",
    d: "M314.588,171.1l7.31,23.054L318.665,337.26H305.451L298,183.049l.984-11.949Z",
    transform: "translate(-181.744 -56.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "cls-25",
    d: "M309.8,171.1l7.169,28.256h5.2l46.53,137.9h10.824L346.771,189.8l-6.326-18.7Z",
    transform: "translate(-176.956 -56.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "cls-14",
    d: "M286.7,88.7l-.281,1.265a4.983,4.983,0,0,0,4.217,5.764l2.109.281a4.983,4.983,0,0,0,5.764-4.217l.281-1.265Z",
    transform: "translate(-186.468 -78.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "cls-26",
    d: "M314.961,116.1l9.419.281-3.936,5.764v45.546l-5.482,11.668L309.9,165.3l7.029-43.578Z",
    transform: "translate(-176.916 -69.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "cls-3",
    d: "M342.459,100.774a14.986,14.986,0,0,0-3.374-8.435,14.1,14.1,0,0,0-7.029-4.639,9.247,9.247,0,0,0-3.936-.562c-1.687.141-3.374.422-5.061-.281-2.249-.984-3.936-2.952-5.9-4.217a5.2,5.2,0,0,0-1.546-.7h0a7.894,7.894,0,0,0-7.029.843,8.571,8.571,0,0,0-3.374,6.326,12.425,12.425,0,0,0,1.687,7.029,15.065,15.065,0,0,0,4.78,4.639,5.767,5.767,0,0,0-.141,1.546,15.514,15.514,0,0,0,29.24,7.872A16.106,16.106,0,0,0,342.459,100.774Zm-32.332-2.952a18.7,18.7,0,0,1-1.968-2.671,11.222,11.222,0,0,1-1.968-6.326,8.434,8.434,0,0,1,2.812-5.9,6.765,6.765,0,0,1,2.249-1.125,3.061,3.061,0,0,0-1.125.7,8.094,8.094,0,0,0-2.53,5.764,13.668,13.668,0,0,0,4.358,11.105v.141C311.391,98.947,310.689,98.384,310.126,97.822Z",
    transform: "translate(-178.829 -81.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "cls-10",
    d: "M326.612,102.5a2.924,2.924,0,1,0,3.374-2.39A2.98,2.98,0,0,0,326.612,102.5Z",
    transform: "translate(-170.152 -73.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    className: "cls-14",
    d: "M320.856,90.1a10.471,10.471,0,0,0-9.559,5.623l-.422,1.968-.281,1.827V99.8h0l-.843,5.061c-1.125,6.888,3.233,13.776,10.121,15.042a12.793,12.793,0,0,0,14.9-10.4l.984-6.185h0C335.9,103.315,337.725,91.366,320.856,90.1Z",
    transform: "translate(-177.048 -77.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    className: "cls-15",
    d: "M320.66,102.039c-.7-.422-5.764-1.406-6.326-1.125a1.616,1.616,0,0,0-.7,1.968,3.023,3.023,0,0,0,1.265,1.687,4.88,4.88,0,0,0,4.78.422,3.077,3.077,0,0,0,1.406-1.265A1.341,1.341,0,0,0,320.66,102.039Z",
    transform: "translate(-175.445 -73.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    className: "cls-3",
    d: "M319.6,90.468a22.7,22.7,0,0,1,5.061,1.406,10.146,10.146,0,0,1,3.374,1.968c3.233,2.812.281,8.716-.7,11.808-.281.7-.562,1.687-.141,2.249a1.74,1.74,0,0,0,2.39,0,6.921,6.921,0,0,0,1.406-2.109,3.1,3.1,0,0,1,1.968-1.546l-.562-14.058c0-.141-8.856-.281-9.559-.281A8.634,8.634,0,0,0,319.6,90.468Z",
    transform: "translate(-172.98 -78.044)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_404",
    "data-name": 404,
    className: "cls-27",
    transform: "translate(960 421)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -146.633,
    y: 0
  }, "404"))), /*#__PURE__*/React.createElement("text", {
    id: "Str\\xE1nka_kterou_hled\\xE1te_neexistuje.",
    "data-name": "Str\\xE1nka, kterou hled\\xE1te, neexistuje.",
    className: "cls-28",
    transform: "translate(668 760)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Str\xE1nka, kterou hled\xE1te, neexistuje.")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.708237f0a206ddf999a69012ec355495.svg";
export { ForwardRef as ReactComponent };